const slicer = state => state.favourites;

const checkFormsProcessing = (formKeys, forms) => formKeys.some(key => forms[key]);

export const selectForms = state => slicer(state).forms ?? {};
export const selectIsAppLoading = state => slicer(state).isAppLoading ?? true;
export const selectIsExpressCheckout = state => slicer(state).isExpressCheckout ?? false;
export const selectIsFormProcessing = (state, ...formKeys) => checkFormsProcessing(formKeys, selectForms(state));
export const selectNotifications = state => slicer(state).notifications ?? {};
export const selectShowAlternativeCollector = state => slicer(state).showAlternativeCollector ?? false;
export const selectShowBillingAddress = state => slicer(state).showBillingAddress ?? false;
